module.exports = __webpack_public_path__ + "img/bg.8089c102.jpg";